import FormSelect from "../../Common/FormSelect";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import calenderIcon from "../../../assets/img/calenderIcon.svg";
import {
  convertGmtToOffest,
  getBrowserGMTOffset,
  hasRoles,
  kindOf,
  showToast,
} from "../../../lib/utility";
import { isReportsPath } from "../../../lib/routeTokens";
import { getDatesFromDay } from "../../../lib/utils";
import {
  getReportDateRange,
  convertDateTimeLocalToReport,
  convertReportToDateTimeLocal,
  addTimeInReportDates,
  getLocalDateOffset,
  getReportEndDateMin,
} from "../../../Wrapper/ReportDateUtils";
import timeOptions, { countries } from "../../../Wrapper/GmtTimeData";
import { authSelector } from "../../Auth/AuthSlice";
import CloseButton from "../../Common/CloseButton";
import ReportDateTimePicker from "../../Common/ReportDateTimePicker";
import FormEnter from "../../Common/FormEnter";
import Modal from "../../Common/Modal";
import Select from "../../Common/Select";
import FilterHeaderPresetSelect, { buildDayOptionsCommonUi } from "../../Common/FilterHeaderPresetSelect";
import UserFilter from "../../Common/UserFilter";

export default function SubmissionFilter({
  modal,
  closeModal,
  onApplyFilter,
  canSelectUsers,
  initialFilterData,
}) {
  const { t } = useTranslation(["submissionReport", "common"]);
  let bodyForDate = getReportDateRange(10);
  const getInitialValues = () => {
    const { startDate, endDate } = getReportDateRange(10);
    return {
      gmtOffset: getBrowserGMTOffset(),
      startDate: convertReportToDateTimeLocal(startDate),
      endDate: convertReportToDateTimeLocal(endDate),
      time: null,
      month: "",
      date: "",
      senderId: "",
      status: "%",
      country: "%",
    };
  };

  const initialValues = {
    gmtOffset: initialFilterData?.toGmt || getBrowserGMTOffset(),
    startDate: initialFilterData?.startdate
      ? convertReportToDateTimeLocal(initialFilterData.startdate)
      : convertReportToDateTimeLocal(bodyForDate.startDate),
    endDate: initialFilterData?.enddate
      ? convertReportToDateTimeLocal(initialFilterData.enddate)
      : convertReportToDateTimeLocal(bodyForDate.endDate),
    time: initialFilterData?.reportType || null,
    month: "",
    date: "",
    senderId: initialFilterData?.senderId || "",
    status: initialFilterData?.messageStatus || "%",
    country: initialFilterData?.country || "%",
  };

  const [filterData, setFilterData] = useState(initialValues);
  const [daySelector, setDaySelector] = useState("10");

  const { user } = useSelector(authSelector);
  const location = useLocation();
  const isSupers =
    canSelectUsers === undefined
      ? hasRoles("admin,superadmin,system,seller,manager", user) &&
        isReportsPath(location)
      : canSelectUsers;

  const [selectUsers, setSelectUsers] = useState({
    allowed: isSupers,
    userIds: "",
    next: false,
  });

 const getFilterObj = () => {
  const reportType = filterData.time;

  const filterObj = {
    status: filterData.status,
    time: reportType,
    reportType,
    date: filterData.date,
    country: filterData.country,
    month: filterData.month,
    senderId: filterData.senderId || "",
    toGmt: filterData.gmtOffset,
    ...(isSupers ? { clientId: selectUsers.userIds || "%" } : {}),
  };

  if (reportType === null) {
    filterObj.startdate = convertDateTimeLocalToReport(filterData.startDate, false);
    filterObj.enddate = convertDateTimeLocalToReport(filterData.endDate, false);
  } else if (reportType === "Monthly" && filterData.month) {
    filterObj.startdate = filterData.month + "-01 00:00:00.000";
    filterObj.enddate = "2020-01-01 00:00:00.000";
  } else if (reportType === "Daily" && filterData.date) {
    filterObj.startdate = filterData.date + " 00:00:00.000";
    filterObj.enddate = "2020-01-01 00:00:00.000";
  }

  return addTimeInReportDates(
    filterObj,
    convertGmtToOffest(filterData.gmtOffset)
  );
};
  const handleApplyClick = () => {
    if (filterData.time === "Daily") {
      if (filterData.date === "") {
        showToast(
          t("messages.pleaseSelectDate", {
            defaultValue: "Please select the date",
          }),
          "warning"
        );
        return;
      }
    } else if (filterData.time === "Monthly") {
      if (filterData.month === "") {
        showToast(
          t("messages.pleaseSelectDate", {
            defaultValue: "Please select the date",
          }),
          "warning"
        );
        return;
      }
    } else {
      if (filterData.startDate === "" || filterData.endDate === "") {
        showToast(
          t("messages.pleaseSelectStartEndDate", {
            defaultValue: "Please select Start and End date",
          }),
          "warning"
        );
        return;
      }
    }

    kindOf(onApplyFilter, "function") && onApplyFilter(getFilterObj());
    modalClose();
  };
  const handleResetClick = () => {
    setFilterData(getInitialValues());
    setDaySelector("10");
  };
  const handleFilterSubmit = () => {
    handleApplyClick();
  };
  const handleTimeChange = (e) => {
    let time = e.target.value;
    setFilterData((prev) => ({
      ...prev,
      time: time === "Custom" ? null : time,
    }));
  };
  const handleFilterDataChange = (e) => {
    const { value, id } = e.target;

    setFilterData((prev) => ({
      ...prev,
      ...(id === "campaign" && value !== ""
        ? { checkA: "campaign" }
        : { checkA: "multiple" }),
      ...(id === "checkA" ? { campaign: "" } : {}),
      [id]: value,
      ...(filterData.campaign === "" &&
      (id === "checkA" || id === "campaign") &&
      value === ""
        ? { checkA: "multiple" }
        : {}),
    }));
  };
  const modalClose = () => {
    setSelectUsers({
      allowed: isSupers,
      userIds: "",
      next: false,
    });
    closeModal();
  };
  const handleDayChange = (e) => {
    let value = e.target.value;
    setDaySelector(value);

    let { startDate, endDate } = getDatesFromDay(value);

    if (startDate && !startDate.includes(" ")) {
      startDate = startDate + " 00:00:00.000";
    }
    if (endDate && !endDate.includes(" ")) {
      const now = new Date();
      const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      if (endDate === todayStr) {
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        endDate = endDate + ` ${hours}:${minutes}:${seconds}.000`;
      } else {
        endDate = endDate + " 23:59:59.000";
      }
    }

    const convertedStartDate = convertReportToDateTimeLocal(startDate);
    const convertedEndDate = convertReportToDateTimeLocal(endDate);

    setFilterData((prev) => ({
      ...prev,
      startDate: convertedStartDate,
      endDate: convertedEndDate,
    }));
  };

  const minSelectableDate = getLocalDateOffset(30);
  const maxSelectableDate = getLocalDateOffset(0);
  const endDateMin = getReportEndDateMin(filterData.startDate, 30);
  const minSelectableMonth = minSelectableDate.slice(0, 7);
  const maxSelectableMonth = maxSelectableDate.slice(0, 7);

  return (
    <>
      <UserFilter
        modalClose={modalClose}
        onNextClick={(value) => setSelectUsers(value)}
        onApplyFilter={onApplyFilter}
        userModalParams={{ canSelectUsers, ifNotAll: true }}
        showShelfName
      />
      {(!selectUsers.allowed ||
        (selectUsers.allowed &&
          selectUsers.userIds !== "" &&
          selectUsers.next)) && (
        <Modal show={modal} close={modalClose} justify="center">
          <div className="modal-header">
            <div className="d-flex gap-2 align-items-center">
              <h6 className="modal-title d-flex align-items-center fs-22">
                <img src={calenderIcon} loading="lazy" />
                {t("commonUi.filter", { ns: "common" })}
              </h6>
              <FilterHeaderPresetSelect
              value={daySelector}
              onChange={handleDayChange}
              options={buildDayOptionsCommonUi(t)}
              dropdownStyle={{ scale: "0.9" }}
            />
            </div>
            <CloseButton theme={"dark"} onClick={modalClose} />
          </div>
          <FormEnter onSubmit={handleFilterSubmit}>
            <div className="modal-body py-2 px-3 bg-white">
              <div className="row filter g-3">
                <div className="col-md-12">
                  <label className="form-label">{t("commonUi.gmt", { ns: "common" })}</label>
                                    <Select
                    options={timeOptions.map((gmt) => ({ id: gmt.value, label: gmt.label }))}
                    value={filterData.gmtOffset}
                    onChange={(value) =>
                      handleFilterDataChange({ target: { id: "gmtOffset", value } })
                    }
                    style={{ fontSize: "14px" }}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{t("commonUi.time", { ns: "common" })}</label>
                  <FormSelect
                    className="form-select text-capitalize"
                    onChange={handleTimeChange}
                    value={filterData.time || "Custom"}
                  >
                    <option value="Daily">
                      {t("filter.daily", { defaultValue: "Daily" })}
                    </option>
                    <option value="Monthly">
                      {t("filter.monthly", { defaultValue: "Monthly" })}
                    </option>
                    <option value="Custom">
                      {t("filter.custom", { defaultValue: "Custom" })}
                    </option>
                  </FormSelect>
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{t("commonUi.country", { ns: "common" })}</label>
                  <Select
                    options={[{ code: "%", name: "ALL" }, ...countries].map(
                      (country) => ({
                        id: country.code,
                        label: country.name,
                      })
                    )}
                    onChange={(value) =>
                      handleFilterDataChange({
                        target: { id: "country", value },
                      })
                    }
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{t("commonUi.sender", { ns: "common" })}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filterData.senderId}
                    id="senderId"
                    onChange={handleFilterDataChange}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{t("commonUi.status", { ns: "common" })}</label>
                  <FormSelect
                    className="form-select text-capitalize"
                    value={filterData.status}
                    id="status"
                    onChange={handleFilterDataChange}
                  >
                    <option value="%">{t("commonUi.all", { ns: "common" })}</option>
                    <option value="Q">
                      {t("filter.status.queued", { defaultValue: "Queued" })}
                    </option>
                    <option value="C">
                      {t("filter.status.processing", {
                        defaultValue: "Processing",
                      })}
                    
                    </option>
                    <option value="P">
                      {t("filter.status.processed", {
                        defaultValue: "Processed",
                      })}
                    </option>
                    <option value="F">
                      {t("filter.status.nonResponding", {
                        defaultValue: "NonResponding",
                      })}
                    </option>
                  </FormSelect>
                </div>
                {filterData.time === "Daily" && (
                  <div className="row mb-3">
                    <div className="col-12">
                      <label className="form-label">{t("commonUi.date", { ns: "common" })}</label>
                      <ReportDateTimePicker
                        type="date"
                        className="form-control text-uppercase"
                        id="date"
                        name="date"
                        value={filterData.date}
                        onChange={handleFilterDataChange}
                        required
                        min={minSelectableDate}
                        max={maxSelectableDate}
                      />
                    </div>
                  </div>
                )}
                {filterData.time === "Monthly" && (
                  <div className="row mb-3">
                    <div className="col-12">
                      <label className="form-label">{t("commonUi.month", { ns: "common" })}</label>
                      <ReportDateTimePicker
                        type="month"
                        className="form-control text-capitalize"
                        id="month"
                        name="month"
                        value={filterData.month}
                        onChange={handleFilterDataChange}
                        required
                        min={minSelectableMonth}
                        max={maxSelectableMonth}
                      />
                    </div>
                  </div>
                )}
                {filterData.time === null && (
                  <>
                    <div className="row mb-3">
                      <div className="col-12">
                        <label className="form-label">{t("commonUi.fromDateTime", { ns: "common" })}</label>
                        <ReportDateTimePicker
                          type="datetime-local"
                          className="form-control text-uppercase"
                          id="startDate"
                          name="startDate"
                          value={filterData.startDate}
                          onChange={handleFilterDataChange}
                          required
                          min={minSelectableDate}
                          max={maxSelectableDate}
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12">
                        <label className="form-label">{t("commonUi.toDateTime", { ns: "common" })}</label>
                        <ReportDateTimePicker
                          type="datetime-local"
                          className="form-control text-uppercase"
                          id="endDate"
                          name="endDate"
                          value={filterData.endDate}
                          onChange={handleFilterDataChange}
                          required
                          min={endDateMin}
                          max={maxSelectableDate}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer d-block bg-white">
              <div className="row g-3">
                <div className="col-6 mt-0">
                  <button
                    type="button"
                    className="btn fs-16 fw-500 br-12 w-100 px-4 py-2 border_lightgray_1 me-2"
                    onClick={handleResetClick}
                  >
                    {t("commonUi.reset", { ns: "common" })}
                  </button>
                </div>
                <div className="col-6 mt-0">
                  <button
                    type="submit"
                    className="cbtn text-white btn w-100 fs-16 fw-500 br-12 px-4 py-2 border_lightgray_1"
                  >
                    {t("commonUi.apply", { ns: "common" })}
                  </button>
                </div>
              </div>
            </div>
          </FormEnter>
        </Modal>
      )}
    </>
  );
}
